'use strict';
var focusHelper = require('base/components/focus');
window.cart = {};

/**
 * Retrieves the relevant pid value
 * @param {jquery} $el - DOM container for a given add to cart button
 * @return {string} - value to be used when adding product to cart
 */
function getPidValue($el) {
    var pid;

    if ($('#quickViewModal').hasClass('show') && !$('.product-set').length) {
        pid = $($el).closest('.modal-content').find('.product-quickview').data('pid');
    } else if ($('.product-set-detail').length || $('.product-set').length) {
        pid = $($el).closest('.product-detail').find('.product-id').text();
    } else {
        pid = $('.product-detail:not(".bundle-item")').data('pid');
    }

    return pid;
}

/**
 * Retrieve contextual quantity selector
 * @param {jquery} $el - DOM container for the relevant quantity
 * @return {jquery} - quantity selector DOM container
 */
function getQuantitySelector($el) {
    // console.log("Get Quantity Selected on element " + $el);
    var quantitySelected;
    var _quantitySelector = '.quantity-select';
    if ($el && $('.set-items').length) {
        quantitySelected = $($el).closest('.product-detail').find('.quantity-select');
    } else if ($el && $('.product-bundle').length) {
        if ($('.js-b2b-quantity-select').length > 0) {
            _quantitySelector = '.js-b2b-quantity-select';
        }
        var quantitySelectedModal = $($el).closest('.modal-footer').find(_quantitySelector);
        var quantitySelectedPDP = $($el).closest('.bundle-footer').find(_quantitySelector);
        if (quantitySelectedModal.val() === undefined) {
            quantitySelected = quantitySelectedPDP;
        } else {
            quantitySelected = quantitySelectedModal;
        }
    } else {
        if ($('.js-b2b-quantity-select').length > 0) {
            _quantitySelector = '.js-b2b-quantity-select';
        }
        quantitySelected = $(_quantitySelector);
    }
    return quantitySelected;
}

/**
 * Retrieves the value associated with the Quantity pull-down menu
 * @param {jquery} $el - DOM container for the relevant quantity
 * @return {string} - value found in the quantity input
 */
function getQuantitySelected($el) {
    var _quantitiesSelected = getQuantitySelector($el);
    var _variantQuantities;
    var _productVariants = $el.data('variants');
    if (window.customer.isB2B === true && _productVariants) {
        _variantQuantities = [];
        _quantitiesSelected.each(function(idx, _select) {
            var _attrValue = $(_select).attr('data-attr-value');
            var _attrID = $(_select).attr('data-attr-id');
            var productOption = $(_select).find('option:eq(0)');
            if (productOption.length > 0){
                var productOptionUrl = $(_select).find('option:eq(0)').attr('data-url');
                if (productOptionUrl){
                    var productID = productOptionUrl.substring(
                        productOptionUrl.indexOf("pid=") + 4, 
                        productOptionUrl.lastIndexOf("&quantity")
                    );
                    if (productID) {
                        var _value = productID + '|' + _attrID + '|' + _attrValue +  '|' + $(_select).val();
                        _variantQuantities.push(_value);
                    }
                }
            }
        });
    } else {
        _variantQuantities = _quantitiesSelected.val();
    }

    return _variantQuantities;
}

/**
 * Process the attribute values for an attribute that has image swatches
 *
 * @param {Object} attr - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {Object[]} attr.values - Array of attribute value objects
 * @param {string} attr.values.value - Attribute coded value
 * @param {string} attr.values.url - URL to de/select an attribute value of the product
 * @param {boolean} attr.values.isSelectable - Flag as to whether an attribute value can be
 *     selected.  If there is no variant that corresponds to a specific combination of attribute
 *     values, an attribute may be disabled in the Product Detail Page
 * @param {jQuery} $productContainer - DOM container for a given product
 * @param {Object} msgs - object containing resource messages
 */
function processSwatchValues(attr, $productContainer, msgs) {
    attr.values.forEach(function (attrValue) {
        var $attrValue = $productContainer.find('[data-attr="' + attr.id + '"] [data-attr-value="' +
            attrValue.value + '"]');
        var $swatchButton = $attrValue.parent();

        if (attrValue.selected) {
            $attrValue.addClass('selected');
            $attrValue.siblings('.selected-assistive-text').text(msgs.assistiveSelectedText);
        } else {
            $attrValue.removeClass('selected');
            $attrValue.siblings('.selected-assistive-text').empty();
        }

        if (attrValue.url) {
            $swatchButton.attr('data-url', attrValue.url);
        } else {
            $swatchButton.removeAttr('data-url');
        }

        // Disable if not selectable
        $attrValue.removeClass('selectable unselectable');

        $attrValue.addClass(attrValue.selectable ? 'selectable' : 'unselectable');
    });
}

/**
 * Process attribute values associated with an attribute that does not have image swatches
 *
 * @param {Object} attr - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {Object[]} attr.values - Array of attribute value objects
 * @param {string} attr.values.value - Attribute coded value
 * @param {string} attr.values.url - URL to de/select an attribute value of the product
 * @param {boolean} attr.values.isSelectable - Flag as to whether an attribute value can be
 *     selected.  If there is no variant that corresponds to a specific combination of attribute
 *     values, an attribute may be disabled in the Product Detail Page
 * @param {jQuery} $productContainer - DOM container for a given product
 */
function processNonSwatchValues(attr, $productContainer) {
    var $attr = '[data-attr="' + attr.id + '"]';
    var $defaultOption = $productContainer.find($attr + ' .select-' + attr.id + ' option:first');
    $defaultOption.attr('value', attr.resetUrl);

    attr.values.forEach(function (attrValue) {
        var $attrValue = $productContainer
            .find($attr + ' [data-attr-value="' + attrValue.value + '"]');
        $attrValue.attr('value', attrValue.url)
            .removeAttr('disabled');

        if (!attrValue.selectable) {
            $attrValue.attr('disabled', true);
        }
    });
}

/**
 * Routes the handling of attribute processing depending on whether the attribute has image
 *     swatches or not
 *
 * @param {Object} attrs - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {jQuery} $productContainer - DOM element for a given product
 * @param {Object} msgs - object containing resource messages
 */
function updateAttrs(attrs, $productContainer, msgs) {
    // Currently, the only attribute type that has image swatches is Color.
    var attrsWithSwatches = ['color'];

    attrs.forEach(function (attr) {
        if (attrsWithSwatches.indexOf(attr.id) > -1) {
            processSwatchValues(attr, $productContainer, msgs);
        } else {
            processNonSwatchValues(attr, $productContainer);
        }
    });
}

/**
 * Updates the availability status in the Product Detail Page
 *
 * @param {Object} response - Ajax response object after an
 *                            attribute value has been [de]selected
 * @param {jQuery} $productContainer - DOM element for a given product
 */
function updateAvailability(response, $productContainer) {
    var availabilityValue = '';
    var availabilityMessages = response.product.availability.messages;
    if (!response.product.readyToOrder) {
        availabilityValue = '<li><div>' + response.resources.info_selectforstock + '</div></li>';
    } else {
        availabilityMessages.forEach(function (message) {
            availabilityValue += '<li><div>' + message + '</div></li>';
        });
    }

    $($productContainer).trigger('product:updateAvailability', {
        product: response.product,
        $productContainer: $productContainer,
        message: availabilityValue,
        resources: response.resources
    });
}

/**
 * Generates html for product attributes section
 *
 * @param {array} attributes - list of attributes
 * @return {string} - Compiled HTML
 */
function getAttributesHtml(attributes) {
    if (!attributes) {
        return '';
    }

    var html = '';

    attributes.forEach(function (attributeGroup) {
        if (attributeGroup.ID === 'mainAttributes') {
            attributeGroup.attributes.forEach(function (attribute) {
                html += '<div class="attribute-values">' + attribute.label + ': '
                    + attribute.value + '</div>';
            });
        }
    });

    return html;
}

/**
 * @typedef UpdatedOptionValue
 * @type Object
 * @property {string} id - Option value ID for look up
 * @property {string} url - Updated option value selection URL
 */

/**
 * @typedef OptionSelectionResponse
 * @type Object
 * @property {string} priceHtml - Updated price HTML code
 * @property {Object} options - Updated Options
 * @property {string} options.id - Option ID
 * @property {UpdatedOptionValue[]} options.values - Option values
 */

/**
 * Updates DOM using post-option selection Ajax response
 *
 * @param {OptionSelectionResponse} optionsHtml - Ajax response optionsHtml from selecting a product option
 * @param {jQuery} $productContainer - DOM element for current product
 */
function updateOptions(optionsHtml, $productContainer) {
	// Update options
    $productContainer.find('.product-options').empty().html(optionsHtml);
}

/**
 * Dynamically creates Bootstrap carousel from response containing images
 * @param {Object[]} imgs - Array of large product images,along with related information
 * @param {jQuery} $productContainer - DOM element for a given product
 */
function createCarousel(imgs, $productContainer) {
    var carousel = $productContainer.find('.carousel');
    $(carousel).carousel('dispose'); 
    var carouselId = $(carousel).attr('id');

    if ($(window).width() > 840) {
    $(carousel).empty().append(`
        <div class="product-view-carousel">
            <div class="carousel-inner" role="listbox">
                <div class="carousel-product-arrows-zoom">
                    <a class="carousel-control-prev" href="#${carouselId}" role="button" data-slide="prev">
                        <span class="carousel-icon-prev" aria-hidden="true"></span>
                    </a>
                    <a class="carousel-control-next" href="#${carouselId}" role="button" data-slide="next">
                        <span class="carousel-icon-next" aria-hidden="true"></span>
                    </a>
                    <span class="zoom zoom-icon-js">
                        <span class="icon-zoom"></span>
                    </span>
                </div>
            </div>
            <ol class="carousel-indicators liste-inline" aria-hidden="true"></ol>
        </div>
    `);
    } else {
        $(carousel).empty().append(`
            <div class="product-view-carousel">
                <div class="carousel-inner" role="listbox"></div>
                <ol class="carousel-indicators liste-inline" aria-hidden="true"></ol>
                <div class="carousel-product-arrows-zoom">
                    <a class="carousel-control-prev d-none" href="#${carouselId}" role="button" data-slide="prev">
                        <span class="carousel-icon-prev" aria-hidden="true"></span>
                    </a>
                    <a class="carousel-control-next d-none" href="#${carouselId}" role="button" data-slide="next">
                        <span class="carousel-icon-next" aria-hidden="true"></span>
                    </a>
                    <span class="zoom d-none">
                        <span class="icon-zoom"></span>
                    </span>
                </div>
            </div>
        `); 
    }

    var li = "", itemZoom = "",itemZoomLarge = "";

    if (imgs.length > 0) {
        for (var i = 0; i < imgs.length; i++) {
            li += `
                <li data-target="#${carouselId}" data-slide-to="${i}" class="">
                    <img src="${imgs[i].url}" class="d-block img-fluid" alt="${imgs[i].alt} image number ${parseInt(imgs[i].index, 10)}" itemprop="image" />
                </li>
            `;

            itemZoom += `
                <div class="carousel-item zoom zoom-icon-js">
                    <img src="${imgs[i].url}" itemprop="image" width="500" height="500" style="user-select: none;" />
                </div>
            `;
            itemZoomLarge += `
                <div class="carousel-item js-carousel-item">
                    <img src="${imgs[i].url}" itemprop="image" width="500" height="500" style="user-select: none;" />
                </div>
            `;
        }
    }

    $(carousel).find('.carousel-indicators').append(li);
    $(carousel).find('.carousel-inner').append(itemZoom);
    $('.js-carousel-inner').empty().append(itemZoomLarge);

    $($(carousel).find('.carousel-item')).first().addClass('active');
    $($(carousel).find('.carousel-indicators > li')).first().addClass('active');

    if (imgs.length === 1) {
        $(carousel).find('.carousel-indicators, a[class^="carousel-control-"]').remove();
    }

    $(carousel).carousel();
    $(carousel).find('.carousel-indicators').attr('aria-hidden', true);

    if ($(window).width() > 992) {
        $('.zoom').zoom();
    }

    if ($(window).width() > 992) {
      function toggleCarouselArrows() {
        var $carousel = $(".product-view-carousel");
        var itemCarousel = $carousel.find(".carousel-item");
        var $indicators = $carousel.find(".carousel-indicators li");
        var $prevArrow = $carousel.find(".carousel-control-prev");
        var $nextArrow = $carousel.find(".carousel-control-next");

        if (itemCarousel.length == 1) {
          $prevArrow.removeClass("d-flex").addClass("arrow-disabled");
          $nextArrow.removeClass("d-flex").addClass("arrow-disabled");
        } else {
          $prevArrow.removeClass("arrow-disabled").addClass("d-flex");
          $nextArrow.removeClass("arrow-disabled").addClass("d-flex");

          if ($indicators.first().hasClass("active")) {
            $prevArrow.removeClass("d-flex").addClass("arrow-disabled");
          } else {
            $prevArrow.removeClass("arrow-disabled").addClass("d-flex");
          }

          if ($indicators.last().hasClass("active")) {
            $nextArrow.removeClass("d-flex").addClass("arrow-disabled");
          } else {
            $nextArrow.removeClass("arrow-disabled").addClass("d-flex");
          }
        }
      }

      toggleCarouselArrows();
      $(".carousel-product-arrows-zoom a").on("click", function () {
        setTimeout(toggleCarouselArrows, 500);
      });

      $(".carousel-indicators li").on("click", function () {
        setTimeout(toggleCarouselArrows, 500);
      });
    }  
}




/**
 * Parses JSON from Ajax call made whenever an attribute value is [de]selected
 * @param {Object} response - response from Ajax call
 * @param {Object} response.product - Product object
 * @param {string} response.product.id - Product ID
 * @param {Object[]} response.product.variationAttributes - Product attributes
 * @param {Object[]} response.product.images - Product images
 * @param {boolean} response.product.hasRequiredAttrsSelected - Flag as to whether all required
 *     attributes have been selected.  Used partially to
 *     determine whether the Add to Cart button can be enabled
 * @param {jQuery} $productContainer - DOM element for a given product.
 */
function handleVariantResponse(response, $productContainer) {
    // console.log("product container :: " + $productContainer);
    var isChoiceOfBonusProducts =
        $productContainer.parents('.choose-bonus-product-dialog').length > 0;
    var isVaraint;
    if (response.product.variationAttributes) {
        updateAttrs(response.product.variationAttributes, $productContainer, response.resources);
        isVaraint = response.product.productType === 'variant';
        if (isChoiceOfBonusProducts && isVaraint) {
            $productContainer.parent('.bonus-product-item')
                .data('pid', response.product.id);

            $productContainer.parent('.bonus-product-item')
                .data('ready-to-order', response.product.readyToOrder);
        }
    }

    // Update primary images
    var primaryImageUrls = response.product.images.large;
    createCarousel(primaryImageUrls, $productContainer);

    // Update pricing
    if (!isChoiceOfBonusProducts) {
        var $priceSelector = $('.prices .price', $productContainer).length
            ? $('.prices .price', $productContainer)
            : $('.prices .price');
        $priceSelector.replaceWith(response.product.price.html);
    }
    if (response.product.discount>0) {
        $('.prices.tec-bar-price .price-with-discount').append(`<span class="discount-container hide"><span class="value">-${response.product.discount}%</span></span>`);
    }

    // Update promotions
    $productContainer.find('.promotions').empty().html(response.product.promotionsHtml);

    updateAvailability(response, $productContainer);

    if (isChoiceOfBonusProducts) {
        var $selectButton = $productContainer.find('.select-bonus-product');
        $selectButton.trigger('bonusproduct:updateSelectButton', {
            product: response.product, $productContainer: $productContainer
        });
    } else {
        // Enable "Add to Cart" button if all required attributes have been selected
        $('button.add-to-cart, button.add-to-cart-global, button.update-cart-product-global').trigger('product:updateAddToCart', {
            product: response.product, $productContainer: $productContainer
        }).trigger('product:statusUpdate', response.product);
    }

    // Update attributes
    $productContainer.find('.main-attributes').empty()
        .html(getAttributesHtml(response.product.attributes));
}

/**
 * @typespec UpdatedQuantity
 * @type Object
 * @property {boolean} selected - Whether the quantity has been selected
 * @property {string} value - The number of products to purchase
 * @property {string} url - Compiled URL that specifies variation attributes, product ID, options,
 *     etc.
 */

/**
 * Updates the quantity DOM elements post Ajax call
 * @param {UpdatedQuantity[]} quantities -
 * @param {jQuery} $productContainer - DOM container for a given product
 */
function updateQuantities(quantities, $productContainer, attrObject) {
    if ($productContainer.parent('.bonus-product-item').length <= 0) {  
        if ($('.size-field.selected').length > 0) {          
            var optionsHtml = quantities.map(function (quantity) {
                var selected = quantity.selected ? ' selected ' : '';
                return '<option value="' + quantity.value + '"  data-url="' + quantity.url + '"' +
                    selected + '>' + quantity.value + '</option>';
            }).join('');
            if (window.customer.isB2B === false) {
                // console.log("Pass trough B2C quantity update");
                getQuantitySelector($productContainer).empty().html(optionsHtml);
            } else {
                // console.log("Pass trough B2B quantity update");
                var selectSelector = "select_quantity_" + attrObject.id + "_" + attrObject.value;
                
                var quantityContainer = $('#' + selectSelector).parent('div');
                $('#' + selectSelector).empty().html(optionsHtml);

            }
        }
    }
}

function renderSizesView(sizeValues) {
    for (let i = 0; i < sizeValues.variationAttributes.length; i++) {
      const Attribute = sizeValues.variationAttributes[i];
  
      if (Attribute.attributeId === "TEC_size") {
            $(".select-all-size").empty();
            let htmlButton = "";
            let htmlOption = "";

            $.each(Attribute.values, function (index, attrValue) {
                htmlButton += `
                <div class="sizes-container">
                    <span class="size-field ${
                    attrValue.selected && attrValue.selectable ? "selected" : ""
                    } ${attrValue.selectable ? "selectable" : "size-unselectable"}" data-attr-value="${attrValue.url}" data-size-id=${attrValue.displayValue} data-product-id="${attrValue.quantitInStock.ID}">
                        ${attrValue.displayValue}
                    </span>
                </div>
                `;
                htmlOption += `
                    <option class="${attrValue.selectable ? "selectable" : "size-unselectable"}" ${
                        attrValue.selected ? "selected" : ""} data-attr-value="${attrValue.displayValue}" value="${attrValue.url}">
                        ${attrValue.displayValue}
                    </option>
                `;
            });
    
            $(".select-all-size").html(htmlButton);
            $("select.select-size").html(htmlOption);
            break;
      }
    }
    var errorMessage = $('.size-error-message');
    errorMessage.css('display', 'none');
  }  

  function renderQuantity(sizeValues) {
    for (let i = 0; i < sizeValues.variationAttributes.length; i++) {
      const Attribute = sizeValues.variationAttributes[i];
  
      if (Attribute.attributeId === "TEC_size") {
            $(".selectAllSizeB2B").empty();
            let B2bHtmlButton = "";

            $.each(Attribute.values, function (index, attrValue) {
                B2bHtmlButton += `
                    <div class="d-flex justify-content-between align-items-center var-tec">
                        <div class="tec-var-stock js-availability-message-container-${attrValue.id}-${attrValue.value} align-items-center d-flex item"
                            data-text-available="${attrValue.quantitInStock.msg}"
                            data-text-unavailable="${attrValue.quantitInStock.msg}">
                            <div class="size-text ${attrValue.selectable ? "b2b-size-selectable" : "b2b-size-unselectable"}" data-product-id="${attrValue.quantitInStock.ID}">
                                <span class="b2b-label-size">${attrValue.displayValue}</span><br> 
                                <small class="availability-text js-availability-message-${attrValue.id}-${attrValue.value}" data-stock="${attrValue.quantitInStock.stock}">
                                    ${attrValue.quantitInStock.msg}
                                </small>
                            </div>
                        </div>
                        <div class="tec-var-qunt quantity item">
                            <div class="size-selector-container b2b-customer">
                                ${generateStockOptions(attrValue.quantitInStock.stock,attrValue)}
                            </div>
                        </div> 
                    </div>
                `;
            });
            $(".selectAllSizeB2B").html(B2bHtmlButton);
      }
    }
    var errorMessage = $('.size-error-message');
    errorMessage.css('display', 'none');

    $('.size-selector-container').each(function () {
        const $select = $(this).find('select');
        $select.on('focusin', function(e) {
            e.preventDefault();
                $(this).addClass('focused');
            })
            .on('focusout', function(e) {
                e.preventDefault();
                    $(this).removeClass('focused');
                });

        $(this).find('.plus-btn').on('click', function () {
            if ($select.prop('selectedIndex') < $select.find('option').length - 1) {
                $select.prop('selectedIndex', $select.prop('selectedIndex') + 1).trigger('change');
            }
        });

        $(this).find('.minus-btn').on('click', function () {
            if ($select.prop('selectedIndex') > 0) {
                $select.prop('selectedIndex', $select.prop('selectedIndex') - 1).trigger('change');
            }
        });
    });
  } 

  function generateStockOptions(stock, attrValue, productType) {
    let options = '';
    var attrId = $('.tec-qunt-b2b').data('attr-id');
    if (!attrValue.selectable || !attrValue.listequanti || attrValue.listequanti.length === 0) {
        options += `<option value="0">0</option>`;
    } else {
        const maxStock = Math.min(stock, 50);

        for (let i = 0; i <= maxStock; i++) {
            const isSelected = attrValue.listequanti.includes(i) && attrValue.selectedQuantity === i ? 'selected' : '';
            const urlData = productType !== 'bundle' ? `data-url="${attrValue.url}"` : '';

            options += `<option value="${i}" ${urlData} ${isSelected}>${i}</option>`;
        }
    }
    
    const minusButton = $('.info-product').length > 0 ? `
        <button type="button" class="d-block d-sm-none quantity-btn minus-btn">
            <img class="d-lg-none" src="${minusImgUrl}" alt="Minus" />
        </button>` : '';

    const plusButton = $('.info-product').length > 0 ? `
        <button type="button" class="d-block d-sm-none quantity-btn plus-btn">
            <img class="d-lg-none" src="${plusImgUrl}" alt="Plus" />
        </button>` : '';

    return `
        ${minusButton}
        <select class="size-selector custom-select quantity-select form-control js-b2b-quantity-select 
            ${attrValue.listequanti && attrValue.listequanti.length === 1 && attrValue.listequanti[0] === 0 ? 'disabled-select' : ''}"
            name="quantities[${attrValue.index}]"
            id="select_quantity_${attrId}_${attrValue.value}" 
            ${!attrValue.selectable ? 'disabled' : ''}
            data-attr-value="${attrValue.value}"
            data-attr-id="${attrId}" 
            data-available="true">
            ${options}
        </select>
        ${plusButton}
        `;
}

function quickViewRender() {
    if (window.customer.isB2B) {
        var quantitySelector = $('.b2b-customer:not(.b2c-customer) .quantity-select');
        if ($(".js-b2b-quantity-select:not(.disabled-select)").length > 0 && $('.js-b2b-quantity-select').val() == "0") {
            $('.add-to-cart-global .label-select-size').removeClass('d-none').addClass('d-block');
            $('.add-to-cart-global .label-add-to-cart').removeClass('d-block').addClass('d-none');
            $('.label-select-size').parents('.add-to-cart-global').removeClass('btn-primary').addClass('btn-blue disabled-btn');
        } else {
            $('.add-to-cart-global .label-add-to-cart').removeClass('d-none').addClass('d-block');
            $('.add-to-cart-global .label-select-size').removeClass('d-block').addClass('d-none');
            $('.label-add-to-cart').parents('.add-to-cart-global').removeClass('btn-blue disabled-btn').addClass('btn-primary');
        }
        $('.js-b2b-quantity-select:not(.disabled-select)').on('change', function () {
            var selectedValue = $(this).val();
        
            if (selectedValue !== "0") { 
                $('.add-to-cart-global .label-add-to-cart').removeClass('d-none').addClass('d-block');
                $('.add-to-cart-global .label-select-size').removeClass('d-block').addClass('d-none');
                $('.label-add-to-cart').parents('.add-to-cart-global').removeClass('btn-blue disabled-btn').addClass('btn-primary');
            } else {
                $('.add-to-cart-global').find('.label-select-size').removeClass('d-none').addClass('d-block');
                $('.add-to-cart-global').find('.label-add-to-cart').removeClass('d-block').addClass('d-none');
                $('.add-to-cart-global').removeClass('btn-primary').addClass('btn-blue disabled-btn');
            }
        });    

        $('.js-b2b-quantity-select:not(.disabled-select)').each(function () {
            if ($(this).val() !== "0") {
                $('.add-to-cart-global .label-add-to-cart').removeClass('d-none').addClass('d-block');
                $('.add-to-cart-global .label-select-size').removeClass('d-block').addClass('d-none');
                $('.label-add-to-cart').parents('.add-to-cart-global').removeClass('btn-blue disabled-btn').addClass('btn-primary');
            }
        });
    }
}

/**
 * updates the product view when a product attribute is selected or deselected or when
 *         changing quantity
 * @param {string} selectedValueUrl - the Url for the selected variation value
 * @param {jQuery} $productContainer - DOM element for current product
 */
function attributeSelect(selectedValueUrl, $productContainer, $target) {
    if($productContainer.prevObject.attr('name')=='sort-order'){
        return;
    }

    if (selectedValueUrl) {
        $('body').trigger('product:beforeAttributeSelect',
            { url: selectedValueUrl, container: $productContainer });

        $.ajax({
            url: selectedValueUrl,
            method: 'GET',
            success: function (data) {
                // dataLayerPushOld({
                //     'event': 'productClick',
                //     'ecommerce': {
                //         'click': {
                //             'products': [{
                //                 'id': "{" + data.product.id + "}",
                //                 'name': "{" + data.product.productName + "}",
                //                 'price': "{" + data.product.price.sales.value + "}",
                //                 'category': "{" + data.product.productData.category + "}",
                //                 'brand': "{" + data.product.brand + "}",
                //                 'variant': "{" + data.product.productData.variant + "}"
                //             }]
                //         }
                //     }
                // });
                if (data.product.variationAttributes) {
                    var selectedSize = $('.size-field.selected').data('size-id');
                    renderSizesView(data.product); // Passer la couleur sélectionnée
                    var NewSelectedSize = $('.size-field.selected').data('size-id');
                    if (!window.customer.isB2B) {
                        if ($target === 'color') {
                            if ($('.size-field.selected').length > 0) {
                                if (selectedSize != NewSelectedSize) {
                                    $('.size-field.selected').removeClass('selected');
                                    $("select.quantity-select").html('<option value="0">0</option>');
                                }
                            } else {
                                if (selectedSize != NewSelectedSize) {
                                    $("select.quantity-select").html('<option value="0">0</option>');
                                }
                            }
                        }
                    }
                }
                handleVariantResponse(data, $productContainer);
                updateOptions(data.product.optionsHtml, $productContainer);
                // if B2B pass attr ID & value as extra param to update product ID input field corresponding to selected variant value 
                if (window.customer.isB2B  && $target != 'color') {
                    updateQuantities(data.product.quantities, $productContainer, {
                        id: $target.attr('data-attr-id'),
                        value: $target.attr('data-attr-value')
                    });
                    $('body').trigger('product:afterAttributeSelect', {
                        data: data,
                        container: $productContainer,
                        attribute: {
                            id: $target.attr('data-attr-id'),
                            value: $target.attr('data-attr-value')
                        }
                    });
                } else {
                    updateQuantities(data.product.quantities, $productContainer);
                    $('body').trigger('product:afterAttributeSelect', {
                        data: data,
                        container: $productContainer
                    });
                }
                if (window.customer.isB2B  && $target === 'color') {
                    renderQuantity(data.product);
                    $('.quantity-select').select2({
                        minimumResultsForSearch: -1,
                    }).on('select2:open', () => {
                        $(".select2-container--default").addClass('select2-b2b-quantity');
                    });
                    quickViewRender();
                }
                if ($('.size-unselectable.size-field').length > 0 ) {
                    $('.show-back-in-stock').addClass('d-lg-block').removeClass('d-none');
                } else {
                    $('.show-back-in-stock').addClass('d-none').removeClass('d-lg-block');
                }
                if ($('.size-field.selected').length === 0 && $('.size-field').length > 0) {
                    $("select.quantity-select").html('<option value="0">0</option>');
                }
                $.spinner().stop();
            },
            error: function () {
                $.spinner().stop();
            }
        });
    }
}

/**
 * Retrieves url to use when adding a product to the cart
 *
 * @return {string} - The provided URL to use when adding a product to the cart
 */
function getAddToCartUrl() {
    return $('.add-to-cart-url').val();
}

/**
 * Parses the html for a modal window
 * @param {string} html - representing the body and footer of the modal window
 *
 * @return {Object} - Object with properties body and footer.
 */
function parseHtml(html) {
    var $html = $('<div>').append($.parseHTML(html));

    var body = $html.find('.choice-of-bonus-product');
    var footer = $html.find('.modal-footer').children();

    return { body: body, footer: footer };
}

/**
 * Retrieves url to use when adding a product to the cart
 *
 * @param {Object} data - data object used to fill in dynamic portions of the html
 */
function chooseBonusProducts(data) {
    $('.modal-body').spinner().start();

    if ($('#chooseBonusProductModal').length !== 0) {
        $('#chooseBonusProductModal').remove();
    }
    var bonusUrl;
    if (data.bonusChoiceRuleBased) {
        bonusUrl = data.showProductsUrlRuleBased;
    } else {
        bonusUrl = data.showProductsUrlListBased;
    }

    var htmlString = '<!-- Modal -->'
        + '<div class="modal fade" id="chooseBonusProductModal" tabindex="-1" role="dialog">'
        + '<span class="enter-message sr-only" ></span>'
        + '<div class="modal-dialog choose-bonus-product-dialog" '
        + 'data-total-qty="' + data.maxBonusItems + '"'
        + 'data-UUID="' + data.uuid + '"'
        + 'data-pliUUID="' + data.pliUUID + '"'
        + 'data-addToCartUrl="' + data.addToCartUrl + '"'
        + 'data-pageStart="0"'
        + 'data-pageSize="' + data.pageSize + '"'
        + 'data-moreURL="' + data.showProductsUrlRuleBased + '"'
        + 'data-bonusChoiceRuleBased="' + data.bonusChoiceRuleBased + '">'
        + '<!-- Modal content-->'
        + '<div class="modal-content">'
        + '<div class="modal-header">'
        + '    <span class="">' + data.labels.selectprods + '</span>'
        + '    <button type="button" class="close pull-right" data-dismiss="modal">'
        + '        <span aria-hidden="true">&times;</span>'
        + '        <span class="sr-only"> </span>'
        + '    </button>'
        + '</div>'
        + '<div class="modal-body"></div>'
        + '<div class="modal-footer"></div>'
        + '</div>'
        + '</div>'
        + '</div>';
    $('body').append(htmlString);
    $('.modal-body').spinner().start();

    $.ajax({
        url: bonusUrl,
        method: 'GET',
        dataType: 'json',
        success: function (response) {
            var parsedHtml = parseHtml(response.renderedTemplate);
            $('#chooseBonusProductModal .modal-body').empty();
            $('#chooseBonusProductModal .enter-message').text(response.enterDialogMessage);
            $('#chooseBonusProductModal .modal-header .close .sr-only').text(response.closeButtonText);
            $('#chooseBonusProductModal .modal-body').html(parsedHtml.body);
            $('#chooseBonusProductModal .modal-footer').html(parsedHtml.footer);
            $('#chooseBonusProductModal').modal('show');
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * Updates the Mini-Cart quantity value after the customer has pressed the "Add to Cart" button
 * @param {string} response - ajax response from clicking the add to cart button
 */
function handlePostCartAdd(response) {
    $('.minicart').trigger('count:update', response);
    var messageType = response.error ? 'alert-danger' : 'alert-success';
    // show add to cart toast
    if (response.newBonusDiscountLineItem
        && Object.keys(response.newBonusDiscountLineItem).length !== 0) {
        chooseBonusProducts(response.newBonusDiscountLineItem);
    } else if (response.stockError && response.unavailableProducts) {
            unavailableProducts.forEach(function(idx, product){
            var quantityInputID = "quantities_" + product.attribute.id + '_' + product.attribute.value;
            $('input#' + quantityInputID).val(product.variant.id);
            var _availableTxt = $('.js-availability-message-container-' + product.attribute.id + '-' + product.attribute.value ).attr('data-text-available');
            var _unavailableTxt = $('.js-availability-message-container-' + product.attribute.id + '-' + product.attribute.value ).attr('data-text-unavailable');
            var $txtContainer = $('.js-availability-message-' + product.attribute.id + '-' + product.attribute.value) ;
            var $quantitySelect = $('#select_quantity_'  + product.attribute.id  + '_' +  product.attribute.value);
            if (product.variant.available === true && product.variant.readyToOrder) {
                $txtContainer.empty().text(_availableTxt);
                $quantitySelect.data('available', true);
            } else {
                $txtContainer.empty().text(_unavailableTxt);
                $quantitySelect.data('available', false);
            }
            updateQuantities(data.product.quantities, $productContainer, {
                id: product.attribute.id,
                value: product.attribute.value
            });
        });
    } else {
        if ($('.add-to-cart-messages').length === 0) {
            $('body').append(
                '<div class="add-to-cart-messages"></div>'
            );
        }
        
        $('html, body').animate({
            scrollTop: $('html').offset().top
        }, 300);

        setTimeout(function () {
            $('.minicart').trigger('focusin');
        },500);

        setTimeout(function () {
           $('.minicart .popover').removeClass('show');
        },3500)
    }
}

/**
 * Retrieves the bundle product item ID's for the Controller to replace bundle master product
 * items with their selected variants
 *
 * @return {string[]} - List of selected bundle product item ID's
 */
function getChildProducts() {
    var childProducts = [];
    $('.bundle-item').each(function () {
        childProducts.push({
            pid: $(this).find('.product-id').text(),
            quantity: parseInt($(this).find('label.quantity').data('quantity'), 10)
        });
    });

    return childProducts.length ? JSON.stringify(childProducts) : [];
}

/**
 * Retrieve product options
 *
 * @param {jQuery} $productContainer - DOM element for current product
 * @return {string} - Product options and their selected values
 */
function getOptions($productContainer) {
    var options = $productContainer
        .find('.product-option')
        .map(function () {
            var $elOption = $(this).find('.options-select');
            var urlValue = $elOption.val();
            var selectedValueId = $elOption.find('option[value="' + urlValue + '"]')
                .data('value-id');
            return {
                optionId: $(this).data('option-id'),
                selectedValueId: selectedValueId
            };
        }).toArray();

    return JSON.stringify(options);
}

/**
 * Makes a call to the server to report the event of adding an item to the cart
 *
 * @param {string | boolean} url - a string representing the end point to hit so that the event can be recorded, or false
 */
function miniCartReportingUrl(url) {
    if (url) {
        $.ajax({
            url: url,
            method: 'GET',
            success: function () {
                // reporting urls hit on the server
            },
            error: function () {
                // no reporting urls hit on the server
            }
        });
    }
}

module.exports = {
    attributeSelect: attributeSelect,
    methods: {
        editBonusProducts: function (data) {
            chooseBonusProducts(data);
        }
    },

    focusChooseBonusProductModal: function () {
        $('body').on('shown.bs.modal', '#chooseBonusProductModal', function () {
            $('#chooseBonusProductModal').siblings().attr('aria-hidden', 'true');
            $('#chooseBonusProductModal .close').focus();
        });
    },

    onClosingChooseBonusProductModal: function () {
        $('body').on('hidden.bs.modal', '#chooseBonusProductModal', function () {
            $('#chooseBonusProductModal').siblings().attr('aria-hidden', 'false');
        });
    },

    trapChooseBonusProductModalFocus: function () {
        $('body').on('keydown', '#chooseBonusProductModal', function (e) {
            var focusParams = {
                event: e,
                containerSelector: '#chooseBonusProductModal',
                firstElementSelector: '.close',
                lastElementSelector: '.add-bonus-products'
            };
            focusHelper.setTabNextFocus(focusParams);
        });
    },

    colorAttribute: function () {
        $(document).on('click', '[data-attr="color"] button', function (e) {
            e.preventDefault();

            if ($(this).attr('disabled')) {
                return;
            }
            var $productContainer = $(this).closest('.set-item');
            if (!$productContainer.length) {
                $productContainer = $(this).closest('.product-detail');
            }

            attributeSelect($(this).attr('data-url'), $productContainer, 'color');
        });
    },

    selectAttribute: function () {
        $(document).on('change', 'select[class*="select-"], .options-select', function (e) {
            e.preventDefault();

            var $productContainer = $(this).closest('.set-item');
            if (!$productContainer.length) {
                $productContainer = $(this).closest('.product-detail');
            }
            attributeSelect(e.currentTarget.value, $productContainer);
        });
    },

    availability: function () {
        $(document).on('change', '.quantity-select', function (e) {
            // TEC-61 : do not control stock when selecting quantity for a variant (B2B case)
            /* if ($(this).hasClass('js-b2b-quantity-select')) {
                return false;
            } */
            e.preventDefault();

            var $productContainer = $(this).closest('.product-detail');
            if (!$productContainer.length) {
                $productContainer = $(this).closest('.modal-content').find('.product-quickview');
            }

            if ($('.bundle-items', $productContainer).length === 0) {

                attributeSelect($(e.currentTarget).find('option:selected').data('url'),
                    $productContainer, $(e.currentTarget));
            }
        });
    },

    addToCart: function () {
        $(document).on('click', 'button.add-to-cart, button.add-to-cart-global', function (event) {
         
            var addToCartUrl;
            var pid;
            var pidsObj;
            var setPids;

            var $productContainer = $(this).closest('.product-detail');
            if (!$productContainer.length) {
                $productContainer = $(this).closest('.quick-view-dialog').find('.product-detail');
            }
            var errorMessage = $productContainer.find('.size-error-message')[0],
                sizeSelector = $productContainer.find('.custom-select.form-control.select-TEC_size')[0];
            if(sizeSelector && errorMessage) {

                var $variationContainer = $('.product-desc');
                if ($(".size-field.selected").length == 0) {
                    if (window.innerWidth < 544) {
                        $('html, body').animate({
                            scrollTop: $variationContainer.offset().top
                        }, 500);
                    }
                    errorMessage.style.display = 'block';
                    event.preventDefault();
                    return;
                } else {
                    errorMessage.style.display = 'none';
                }
            }
            if ($(this).hasClass('disabled-btn')) {
                return
            }
            $('body').trigger('product:beforeAddToCart', this);

            if ($('.set-items').length && $(this).hasClass('add-to-cart-global')) {
                setPids = [];

                $('.product-detail').each(function () {
                    if (!$(this).hasClass('product-set-detail')) {
                        setPids.push({
                            pid: $(this).find('.product-id').text(),
                            qty: $(this).find('.quantity-select').val(),
                            options: getOptions($(this))
                        });
                    }
                });
                pidsObj = JSON.stringify(setPids);
            }

            pid = getPidValue($(this));
            window.cart.pid = pid;


            var $productContainer = $(this).closest('.product-detail');
            if (!$productContainer.length) {
                $productContainer = $(this).closest('.quick-view-dialog').find('.product-detail');
            }

            var $productContainer = $(this).closest('.product-detail');
            if (!$productContainer.length) {
                $productContainer = $(this).closest('.quick-view-dialog').find('.product-detail');
            }

            addToCartUrl = getAddToCartUrl();
            // TEC-90
            var _quantitySelected = getQuantitySelected($(this));
            var form = {
                pid: pid,
                pidsObj: pidsObj,
                childProducts: getChildProducts(),
            };
            var _productVariants =$(this).data('variants');
            // TEC-90
            if (window.customer.isB2B && _productVariants) { 
                form.quantities = _quantitySelected.join(',');
            } else {
                form.quantity = _quantitySelected;
            }

            if (!$('.bundle-item').length) {
                form.options = getOptions($productContainer);
            }

            $(this).trigger('updateAddToCartFormData', form);

            if (addToCartUrl) {
                $.ajax({
                    url: addToCartUrl,
                    method: 'POST',
                    data: form,
                    success: function (data) {
                        handlePostCartAdd(data);
                        $('body').trigger('product:afterAddToCart', data);
                        $.spinner().stop();
                        miniCartReportingUrl(data.reportingURL);
                        var productDataLayer = JSON.parse(data.productDataLayer);
                        dataLayerPushOld({ ecommerce: null });
                        dataLayerPushOld({
                          'event': 'addToCart',
                          'ecommerce': {
                            'currencyCode': productDataLayer.currency,
                            'add': {                                
                              'products': [{                        
                                'name': productDataLayer.name,
                                'id': productDataLayer.id,
                                'price': productDataLayer.price,
                                'brand': productDataLayer.brand,
                                'category': productDataLayer.category,
                                'variant': productDataLayer.variant,
                                'quantity': productDataLayer.quantity
                               }]
                            }
                          }
                        });

                        dataLayerPush(data.gaDatalayer.addToCartEvent)

                    },
                    error: function () {
                        $.spinner().stop();
                    }
                });
            }
        });
    },
    selectBonusProduct: function () {
        $(document).on('click', '.select-bonus-product', function () {
            var $choiceOfBonusProduct = $(this).parents('.choice-of-bonus-product');
            var pid = $(this).data('pid');
            var maxPids = $('.choose-bonus-product-dialog').data('total-qty');
            var submittedQty = parseInt($choiceOfBonusProduct.find('.bonus-quantity-select').val(), 10);
            var totalQty = 0;
            $.each($('#chooseBonusProductModal .selected-bonus-products .selected-pid'), function () {
                totalQty += $(this).data('qty');
            });
            totalQty += submittedQty;
            var optionID = $choiceOfBonusProduct.find('.product-option').data('option-id');
            var valueId = $choiceOfBonusProduct.find('.options-select option:selected').data('valueId');
            if (totalQty <= maxPids) {
                var selectedBonusProductHtml = ''
                + '<div class="selected-pid row" '
                + 'data-pid="' + pid + '"'
                + 'data-qty="' + submittedQty + '"'
                + 'data-optionID="' + (optionID || '') + '"'
                + 'data-option-selected-value="' + (valueId || '') + '"'
                + '>'
                + '<div class="col-sm-11 col-9 bonus-product-name" >'
                + $choiceOfBonusProduct.find('.product-name').html()
                + '</div>'
                + '<div class="col-1"><i class="fa fa-times" aria-hidden="true"></i></div>'
                + '</div>'
                ;
                $('#chooseBonusProductModal .selected-bonus-products').append(selectedBonusProductHtml);
                $('.pre-cart-products').html(totalQty);
                $('.selected-bonus-products .bonus-summary').removeClass('alert-danger');
            } else {
                $('.selected-bonus-products .bonus-summary').addClass('alert-danger');
            }
        });
    },
    removeBonusProduct: function () {
        $(document).on('click', '.selected-pid', function () {
            $(this).remove();
            var $selected = $('#chooseBonusProductModal .selected-bonus-products .selected-pid');
            var count = 0;
            if ($selected.length) {
                $selected.each(function () {
                    count += parseInt($(this).data('qty'), 10);
                });
            }

            $('.pre-cart-products').html(count);
            $('.selected-bonus-products .bonus-summary').removeClass('alert-danger');
        });
    },
    enableBonusProductSelection: function () {
        $('body').on('bonusproduct:updateSelectButton', function (e, response) {
            $('button.select-bonus-product', response.$productContainer).attr('disabled',
                (!response.product.readyToOrder || !response.product.available));
            var pid = response.product.id;
            $('button.select-bonus-product', response.$productContainer).data('pid', pid);
        });
    },
    showMoreBonusProducts: function () {
        $(document).on('click', '.show-more-bonus-products', function () {
            var url = $(this).data('url');
            $('.modal-content').spinner().start();
            $.ajax({
                url: url,
                method: 'GET',
                success: function (html) {
                    var parsedHtml = parseHtml(html);
                    $('.modal-body').append(parsedHtml.body);
                    $('.show-more-bonus-products:first').remove();
                    $('.modal-content').spinner().stop();
                },
                error: function () {
                    $('.modal-content').spinner().stop();
                }
            });
        });
    },
    addBonusProductsToCart: function () {
        $(document).on('click', '.add-bonus-products', function () {
            var $readyToOrderBonusProducts = $('.choose-bonus-product-dialog .selected-pid');
            var queryString = '?pids=';
            var url = $('.choose-bonus-product-dialog').data('addtocarturl');
            var pidsObject = {
                bonusProducts: []
            };

            $.each($readyToOrderBonusProducts, function () {
                var qtyOption =
                    parseInt($(this)
                        .data('qty'), 10);

                var option = null;
                if (qtyOption > 0) {
                    if ($(this).data('optionid') && $(this).data('option-selected-value')) {
                        option = {};
                        option.optionId = $(this).data('optionid');
                        option.productId = $(this).data('pid');
                        option.selectedValueId = $(this).data('option-selected-value');
                    }
                    pidsObject.bonusProducts.push({
                        pid: $(this).data('pid'),
                        qty: qtyOption,
                        options: [option]
                    });
                    pidsObject.totalQty = parseInt($('.pre-cart-products').html(), 10);
                }
            });
            queryString += JSON.stringify(pidsObject);
            queryString = queryString + '&uuid=' + $('.choose-bonus-product-dialog').data('uuid');
            queryString = queryString + '&pliuuid=' + $('.choose-bonus-product-dialog').data('pliuuid');
            $.spinner().start();
            $.ajax({
                url: url + queryString,
                method: 'POST',
                success: function (data) {
                    $.spinner().stop();
                    if (data.error) {
                        $('#chooseBonusProductModal').modal('hide');
                        if ($('.add-to-cart-messages').length === 0) {
                            $('body').append('<div class="add-to-cart-messages"></div>');
                        }
                        $('.add-to-cart-messages').append(
                            '<div class="alert alert-danger add-to-basket-alert text-center"'
                            + ' role="alert">'
                            + data.errorMessage + '</div>'
                        );
                        setTimeout(function () {
                            $('.add-to-basket-alert').remove();
                        }, 3000);
                    } else {
                        $('.configure-bonus-product-attributes').html(data);
                        $('.bonus-products-step2').removeClass('hidden-xl-down');
                        $('#chooseBonusProductModal').modal('hide');

                        if ($('.add-to-cart-messages').length === 0) {
                            $('body').append('<div class="add-to-cart-messages"></div>');
                        }
                        $('.minicart-quantity').html(data.totalQty);
                        $('.add-to-cart-messages').append(
                            '<div class="alert alert-success add-to-basket-alert text-center"'
                            + ' role="alert">'
                            + data.msgSuccess + '</div>'
                        );
                        setTimeout(function () {
                            $('.add-to-basket-alert').remove();
                            if ($('.cart-page').length) {
                                location.reload();
                            }
                        }, 1500);
                    }
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    },

    getPidValue: getPidValue,
    getQuantitySelected: getQuantitySelected,
    miniCartReportingUrl: miniCartReportingUrl
};
